/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { PartyStub } from '../models/party-stub';

/**
 * Internal comments
 */
export interface CommentCreate {
  content?: string | null;
  mentions?: Array<PartyStub> | null;
  replyToId?: string | null;
  reportIssue?: boolean;
  resolvesId?: string | null;
}

export class CommentCreate {
  content?: string | null;
  mentions?: PartyStub[] | null;
  replyToId?: string | null;
  reportIssue?: boolean;
  resolvesId?: string | null;

  constructor(value: CommentCreate) {
    this.content = value?.content;
    this.mentions = value?.mentions?.map((x) => new PartyStub(x));
    this.replyToId = value?.replyToId;
    this.reportIssue = value?.reportIssue;
    this.resolvesId = value?.resolvesId;
  }
}
